/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC } from 'react'
import { countryClickGtm } from '@shared/lib/gtm'
import { OldButton } from '@shared/ui/atoms/OldButton'
import { Payee } from '@root/api/ump-catalog-manager'

type CountryButtonProps = {
  country: string
  handleCountryClick: (country: string) => void
  activeCountry: string | null
  icon?: string
  tooltip?: React.ReactElement
  activeService?: Payee
}

const CountryButton: FC<CountryButtonProps> = ({
  country,
  activeCountry,
  handleCountryClick,
  icon,
  tooltip,
  activeService,
}) => {
  const handleClickGTM = () => {
    handleCountryClick(country)
    // @ts-ignore
    countryClickGtm(activeService?.providerName, country || null)
  }

  return (
    <OldButton
      title={country}
      isActive={activeCountry === country}
      onClick={handleClickGTM}
      icon={icon}
      tooltip={tooltip}
    />
  )
}

export default CountryButton
